<template>
	<Teleport to="body">
		<Transition>
			<div class="popup is-active" :class="class" v-if="isActive" @click.self="$emit('close')" >
				<div class="popup__content">
					<button class="popup__close" type="button" @click="handleXButton"></button>
					<div class="popup__head" v-if="slots.head">
						<slot name="head" />
					</div><!-- /.popup__head -->
	
					<div class="popup__inner">
						<div class="popup__body">
							<slot name="body" />
						</div><!-- /.popup__body -->
	
						<div class="popup__actions" v-if="slots.foot">
							<slot name="foot" />
						</div><!-- /.popup__actions -->
					</div><!-- /.popup__inner -->
				</div><!-- /.popup__content -->
			</div><!-- /.popup -->
		</Transition>
	</Teleport>
</template>

<script setup>
import { onMounted, onUnmounted, useSlots, watch, ref } from 'vue'
const slots = useSlots()
const emit = defineEmits(['close', 'popup_x'])

const props = defineProps({
	class: String,
	isActive: Boolean,
})

const handleKeyPress = (event) => {
	if (event.keyCode === 27 && props.isActive) {
		emit('close')
	}
}

const handleXButton = () => {
	emit('close')
	emit('popup_x')
}

onMounted(() => document.addEventListener('keydown', handleKeyPress))
onUnmounted(() => document.removeEventListener('keydown', handleKeyPress))

</script>

<style scoped>
	.v-enter-active,
	.v-leave-active {
		transition: all 0.3s ease;
	}

	.v-enter-from,
	.v-leave-to {
		visibility: hidden;
		opacity: 0;
	}
</style>
